var map = {
	"./common": [
		45559
	],
	"./common.ts": [
		45559
	],
	"./components/I18nFileProvider": [
		31048
	],
	"./components/I18nFileProvider.tsx": [
		31048
	],
	"./components/I18nFormHandler": [
		44421
	],
	"./components/I18nFormHandler.tsx": [
		44421
	],
	"./components/I18nLabelsForm": [
		14591
	],
	"./components/I18nLabelsForm.tsx": [
		14591
	],
	"./en": [
		28226,
		226
	],
	"./en.ts": [
		28226,
		226
	],
	"./helpers": [
		4831
	],
	"./helpers/": [
		4831
	],
	"./helpers/index": [
		4831
	],
	"./helpers/index.ts": [
		4831
	],
	"./it": [
		89645
	],
	"./it.ts": [
		89645
	],
	"./sv": [
		34995,
		995
	],
	"./sv.ts": [
		34995,
		995
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 84051;
module.exports = webpackAsyncContext;